
<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="items"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
  >

  <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
        :item="itemGoal"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :item="itemGoal"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="!readOnly && $can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
        :item="itemGoal"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>


  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from '@shared_components/base_index.vue';
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      // items: [],
      loading: false,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "SA - Qtd", align: "left", sortable: true, value: "previousQuantity" },
        { text: "SA - Preço", align: "left", sortable: true, value: "previousSalePrice" },
        { text: "Volume", align: "left", sortable: true, value: "volume" },
        { text: "Preço total", align: "left", sortable: true, value: "goalTotalPrice" },
        { text: "Ações", value: "action", sortable: false },
      ],
      maskFields: [
        { field: 'previousSalePrice', mask: 'currency'},
        { field: 'goalTotalPrice', mask: 'currency'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Item"
    },
    modelNamePlural: {
      type: String,
      default: "Vendas"
    },
    items: {
      type: Array,
      default: [],
    },
    itemGoal: {
      type: Object,
      default: null,
    },
    extraData: {
      type: Object,
      default: {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() {
     if(this.extraData.accountContext.previousHarvest){
      this.items = this.extraData.accountContext.previousHarvest;
    }

    this.itemGoal.itemGoals = this.items;
  },
  watch: {
    // "extraData": {
    //   handler: function (val, oldVal) {
    //     console.log("extraData changed", this.extraData, val, oldVal);
    //   },
    //   deep: true
    // },
  },
  computed: {
    // tableHeaders() {
    //   return [
    //     { text: "Código", align: "left", sortable: true, value: "code" },
    //     // { text: "Qtd", align: "left", sortable: true, value: "quantity" },
    //     // { text: "Ramo de atividade", align: "left", sortable: false, value: "businessActivity.name" },
    //     ... this.$can('create', this.$router.currentRoute.name) || this.$can('update', this.$router.currentRoute.name) ? [{ text: "Ações", align: "left", sortable: false, value: "action" }] : []
    //   ]
    // }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      // this.loadServerEntries();
    },
    loadServerEntries: function() {
      // this.loading = true;
      // this.$apollo
      //   .query({
      //     query: LOAD_ALL_GOAL,
      //     variables: {
      //       input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
      //         limit: this.options.itemsPerPage,
      //         offset: (this.options.page - 1) * this.options.itemsPerPage,
      //         sortBy: this.options.sortBy,
      //         sortDesc: this.options.sortDesc,
      //         fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
      //         filters: this.filters,
      //       }
      //     },
      //     fetchPolicy: "no-cache"
      //   })
      //   .then(response => {
      //     this.indexItems = response.data.accountContext.goalsIndex.goals; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
      //     this.totalItems = response.data.accountContext.goalsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
      //     this.typeOperators = response.data.accountContext.goalsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
      //     this.serverFields = response.data.accountContext.goalsIndex.serverFields; // seta os campos que podem ser filtrados
      //   })
      //   .catch(response => console.log(response))
      //   .finally(() => (this.loading = false));
    },
     entryUpdated: function(updated){
      // this.loadServerEntries();
      // console.log("update called");
      // this.$refs.baseIndex.showConfirmationUpdateMessage();
      // var newEntry = this.items.filter(item=> item.id == updated.itemId)[0];
      var list = this.items.filter(item=> item.id != updated.itemId);
      // console.log("list", list);
      updated.goalTotalPrice = updated.itemGoals.reduce((accumulator, current)=> {return accumulator + (current.totalPrice||0)}, 0);
      updated.volume = updated.itemGoals.reduce((accumulator, current)=> {return accumulator + (current.packaging.size||0) * (current.quantity||0)}, 0);
      list.push(updated);
    },
    entryCreated: function(itemGoal){
      // this.loadServerEntries();
      // console.log("entryCreated goal index", itemGoal);
      // itemGoal.code = "algo";
      itemGoal.goalTotalPrice = itemGoal.itemGoals.reduce((accumulator, current)=> {return accumulator + (current.totalPrice || 0)}, 0);
      itemGoal.volume = itemGoal.itemGoals.reduce((accumulator, current)=> {return accumulator + (current.packaging.size || 0) * (current.quantity || 0)}, 0);
      this.items.push(itemGoal);
      // console.log("items", this.items);
      // this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      // this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

</script>

<style scoped></style>

